import { AutoCalcBSMap } from "../../constants";

export const autoCalcBS = ((tableValue:{[key: string]: number}, key: string) => {
        // 更新項目に紐づく自動計算項目が存在している場合は、個別の計算処理を呼び出す
        if(AutoCalcBSMap["TCA_CA"].includes(key)){
            // 当座資産
            autoCalcCurrentAssets(tableValue)
        }else if(AutoCalcBSMap["TCA_I"].includes(key)){
            // 棚卸資産
            autoCalcInventory(tableValue)
        }else if(AutoCalcBSMap["TCA_OCA"].includes(key)){
            // その他流動資産
            autoCalcOtherCurrentAssets(tableValue)
        }else if(AutoCalcBSMap["TCA"].includes(key)){
            // 流動資産合計
            autoCalcTotalCurrentAssets(tableValue)
        }else if(AutoCalcBSMap["TFA_TFA"].includes(key)){
            // 有形固定資産
            autoCalcTangibleFixedAssets(tableValue)
        }else if(AutoCalcBSMap["TFA_IaOA"].includes(key)){
            // 投資その他の資産
            autoCalcInvestmentsAndOtherAssets(tableValue)
        }else if(AutoCalcBSMap["TFA"].includes(key)){
            // 固定資産合計
            autoCalcTotalFixedAssets(tableValue)
        }else if(AutoCalcBSMap["TA"].includes(key)){
            // 資産合計
            autoCalcTotalAssets(tableValue)
        }else if(AutoCalcBSMap["TL_TCL"].includes(key)){
            // 流動負債合計
            autoCalcTotalCurrentLiabilities(tableValue)
        }else if(AutoCalcBSMap["TL_TFL"].includes(key)){
            // 固定負債合計
            autoCalcTotalFixedLiabilities(tableValue)
        }else if(AutoCalcBSMap["TL"].includes(key)){
            // 負債合計
            autoCalcTotalLiabilities(tableValue)
        }else if(AutoCalcBSMap["TNA_SE"].includes(key)){
            // 株主資本
            autoCalcStockholdersEquity(tableValue)
        }else if(AutoCalcBSMap["TNA_VaCD"].includes(key)){
            // 評価・換算差額等
            autoCalcValuationAndConversionDifferences(tableValue)
        }else if(AutoCalcBSMap["TNA"].includes(key)){
            // 純資産合計
            autoCalcTotalNetAssets(tableValue)
        }else if(AutoCalcBSMap["TNA"].includes(key)){
            // 負債・純資産合計
            autoCalcTotalLiabilitiesAndNetAssets(tableValue)
        }
})

// 当座資産（現金・預金 + 受取手形 + 売掛金・工事未収入金 + 有価証券）
const autoCalcCurrentAssets = ((tableValue:{[key: string]: number}) => {
    tableValue["TCA_CA"] = inputLimitControl(tableValue["TCA_CA_CaD"] + tableValue["TCA_CA_AR"] + tableValue["TCA_CA_ARaCWUP"] + tableValue["TCA_CA_S"])
    autoCalcTotalCurrentAssets(tableValue)
})
// 棚卸資産（商品・製品 + 半製品・仕掛品 + 原材料・貯蔵品 + 未成工事支出金）
const autoCalcInventory = ((tableValue:{[key: string]: number}) => {
    tableValue["TCA_I"] = inputLimitControl(tableValue["TCA_I_S"] + tableValue["TCA_I_WIP"] + tableValue["TCA_I_RMS"] + tableValue["TCA_I_CIPE"])
    autoCalcTotalCurrentAssets(tableValue)
})
// その他流動資産（前渡金 + 前払費用・未収収益 + その他）
const autoCalcOtherCurrentAssets = ((tableValue:{[key: string]: number}) => {
    tableValue["TCA_OCA"] = inputLimitControl(tableValue["TCA_OCA_AP"] + tableValue["TCA_OCA_PEAI"] + tableValue["TCA_OCA_O"])
    autoCalcTotalCurrentAssets(tableValue)
})
// 流動資産合計（当座資産 + 棚卸資産 + その他流動資産 + 貸倒引当金）
const autoCalcTotalCurrentAssets = ((tableValue:{[key: string]: number}) => {
    tableValue["TCA"] = inputLimitControl(tableValue["TCA_CA"] + tableValue["TCA_I"] + tableValue["TCA_OCA"] + tableValue["TCA_AfDA"])
    autoCalcTotalAssets(tableValue)
})
// 有形固定資産（建物・構築物 + 機械装置 + 車輌運搬具 + 工具器具備品 + 土地 + 建設仮勘定）
const autoCalcTangibleFixedAssets = ((tableValue:{[key: string]: number}) => {
    tableValue["TFA_TFA"] = inputLimitControl(tableValue["TFA_TFA_BaS"] + tableValue["TFA_TFA_ME"] + tableValue["TFA_TFA_VTE"] + tableValue["TFA_TFA_TES"] + tableValue["TFA_TFA_L"] + tableValue["TFA_TFA_CiP"])
    autoCalcTotalFixedAssets(tableValue)
})
// 投資その他の資産（投資有価証券 + その他）
const autoCalcInvestmentsAndOtherAssets = ((tableValue:{[key: string]: number}) => {
    tableValue["TFA_IaOA"] = inputLimitControl(tableValue["TFA_IaOA_IS"] + tableValue["TFA_IaOA_O"])
    autoCalcTotalFixedAssets(tableValue)
})
// 固定資産合計（有形固定資産 + 無形固定資産 + 投資その他の資産）
const autoCalcTotalFixedAssets = ((tableValue:{[key: string]: number}) => {
    tableValue["TFA"] = inputLimitControl(tableValue["TFA_TFA"] + tableValue["TFA_IFA"] + tableValue["TFA_IaOA"])
    autoCalcTotalAssets(tableValue)
})
// 資産合計（流動資産合計 + 固定資産合計 + 繰延資産合計）
const autoCalcTotalAssets = ((tableValue:{[key: string]: number}) => {
    tableValue["TA"] = inputLimitControl(tableValue["TCA"] + tableValue["TFA"] + tableValue["TDA"])
})
// 流動負債合計（支払手形 + 買掛金・工事未払金 + 短期借入金 + 前受金・未成工事受入金 + 未払費用・前受収益 + 賞与引当金 + 未払法人税 + その他流動負債）
const autoCalcTotalCurrentLiabilities = ((tableValue:{[key: string]: number}) => {
    tableValue["TL_TCL"] = inputLimitControl(tableValue["TL_TCL_BP"] + tableValue["TL_TCL_APUC"] + tableValue["TL_TCL_STB"] + tableValue["TL_TCL_APaUCP"] + tableValue["TL_TCL_AEaUR"] + tableValue["TL_TCL_BR"] + tableValue["TL_TCL_UCT"] + tableValue["TL_TCL_OCL"])
    autoCalcTotalLiabilities(tableValue)
})
// 固定負債合計（社債 + 長期借入金 + 退職給付引当金 + その他固定負債）
const autoCalcTotalFixedLiabilities = ((tableValue:{[key: string]: number}) => {
    tableValue["TL_TFL"] = inputLimitControl(tableValue["TL_TFL_CB"] + tableValue["TL_TFL_LTD"] + tableValue["TL_TFL_ARB"] + tableValue["TL_TFL_OFL"])
    autoCalcTotalLiabilities(tableValue)
})
// 負債合計（流動負債合計 + 固定負債合計）
const autoCalcTotalLiabilities = ((tableValue:{[key: string]: number}) => {
    tableValue["TL"] = inputLimitControl(tableValue["TL_TCL"] + tableValue["TL_TFL"])
    autoCalcTotalLiabilitiesAndNetAssets(tableValue)
})
// 株主資本（資本金 + 資本剰余金 + 利益剰余金 + 自己株式(△)）
const autoCalcStockholdersEquity = ((tableValue:{[key: string]: number}) => {
    tableValue["TNA_SE"] = inputLimitControl(tableValue["TNA_SE_C"] + tableValue["TNA_SE_CS"] + tableValue["TNA_SE_RE"] + tableValue["TNA_SE_TS"])
    autoCalcTotalNetAssets(tableValue)
})
// 評価・換算差額等（その他有価証券評価差額金 + 繰延ヘッジ損益 + 土地再評価差額金）
const autoCalcValuationAndConversionDifferences = ((tableValue:{[key: string]: number}) => {
    tableValue["TNA_VaCD"] = inputLimitControl(tableValue["TNA_VaCD_UGoOS"] + tableValue["TNA_VaCD_DGaLoH"] + tableValue["TNA_VaCD_LRD"])
    autoCalcTotalNetAssets(tableValue)
})
// 純資産合計（株主資本 + 評価・換算差額等 + 新株予約権）
const autoCalcTotalNetAssets = ((tableValue:{[key: string]: number}) => {
    tableValue["TNA"] = inputLimitControl(tableValue["TNA_SE"] + tableValue["TNA_VaCD"] + tableValue["TNA_SAR"])
    autoCalcTotalLiabilitiesAndNetAssets(tableValue)
})
// 負債・純資産合計（負債合計 + 純資産合計）
const autoCalcTotalLiabilitiesAndNetAssets = ((tableValue:{[key: string]: number}) => {
    tableValue["TLaNA"] = inputLimitControl(tableValue["TL"] + tableValue["TNA"])
})

const inputLimitControl = ((v: number) => {
    if(v > 99999999){
        v = 99999999
    }else if(v < -99999999){
        v = -99999999
    }else{
        v = v
    }
    return v
})
